import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";
export class SupabaseFontSelectionSummaryService extends SupabaseServiceView<"font_selection_summary"> {
  table = "font_selection_summary" as const;
}
